<template>
  <div class="settings-license">
    <card-dashboard :title="''">
      <div v-if="!loadingLicense">
        <table>
          <tr v-for="(item, i) in sortedData" :key="`item${i}`">
            <th>{{ item.title }}</th>
            <td>{{ item.value }}</td>
          </tr>
        </table>

        <div class="buttons-container">
          <b-upload @input="uploadZip($event, 'license')">
            <a class="button is-link">{{ $t('button.upload.zip') }}</a>
          </b-upload>
          <div class="control update">
            <a @click="update" class="button">{{ $t('button.update') }}</a>
          </div>
        </div>
      </div>
      <loader v-else></loader>
    </card-dashboard>
  </div>
</template>

<script>
import uploadZip from '@/api/uploadZip'
import CardDashboard from '@/components/CardDashboard'
import Loader from '@/components/Loader'
export default {
  components: {
    CardDashboard,
    Loader
  },
  data() {
    return {
      loadingLicense: false,
      license: {}
    }
  },
  mounted() {
    this.refetch()
  },
  computed: {
    sortedData() {
      let arr = []
      for (let el in this.license) {
        arr.push({
          title: el,
          value: this.license[el]
        })
      }
      return this.$lodash.sortBy(arr, el => el.title)
    }
  },
  methods: {
    uploadZip(...args) {
      uploadZip.apply(this, args).then(() => {
        this.refetch()
      })
    },
    refetch() {
      if (!this.loadingLicense) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/settings/license`
        this.loadingLicense = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.license = data
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.loadingLicense = false
          })
      }
    },
    update() {
      let msg = `${this.$t('word.license')}`
      this.$dialog.confirm({
        message: `${this.$t('confirm.update', { msg })}?`,
        onConfirm: () => {
          const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/settings/license`
          this.loadingLicense = true
          return fetch(url, {
            credentials: 'include',
            method: 'POST'
          })
            .then(res => {
              if (!res.ok) {
                throw res.json()
              }
              return res.json()
            })
            .then(() => {
              this.refetch()
              this.$notify({
                message: `${this.$t('notification.updated', { msg })}.`,
                type: 'success'
              })
            })
            .catch(error =>
              error.then(data => {
                this.$notify({
                  message: JSON.parse(data.message).message,
                  type: 'danger'
                })
              })
            )
            .finally(() => {
              this.loadingLicense = false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.settings-license {
  .card-dashboard {
    .card-header {
      display: none;
    }
    .card-content .content {
      .buttons-container {
        display: flex;
        .upload.control {
          display: block;
          float: left;
          height: 1.35rem;
          font-size: 0.9em;
          .button {
            padding: 0;
            height: 100%;
            padding-right: 1.25rem;
            padding-left: 1.25rem;
            color: white;
            background-color: #4bbd4d;
            font-weight: bold;
          }
        }
        .update.control {
          display: block;
          float: left;
          height: 1.35rem;
          font-size: 0.9em;
          margin-left: 1rem;
          .button {
            padding: 0;
            height: 100%;
            padding-right: 1.25rem;
            padding-left: 1.25rem;
            border-color: #2147d0;
            color: #2147d0;
          }
        }
      }
    }
  }
}
</style>
